<div
  #tabsContainer
  class="header header-desktop"
  [ngClass]="{
    'pr-medium-x': theme === TabTheme.IN_MODAL,
    'mr-small-b': theme === TabTheme.DEFAULT || theme === TabTheme.IN_MODAL,
    'border-bottom': bottomBorder && [TabTheme.DEFAULT, TabTheme.IN_MODAL].includes(theme),
    'before-border relative': theme === TabTheme.CLASSIC
  }"
>
  <div class="flex flex--center mobile-reverse">
    <fcom-carousel
      #carousel
      class="flex-1 overflow-auto"
      [align]="align"
      [hasGreyBackground]="hasGreyBackground"
      [nextButtonAriaLabel]="nextButtonAriaLabel"
      [prevButtonAriaLabel]="prevButtonAriaLabel"
      [theme]="theme === TabTheme.HAS_BACKGROUND ? CarouselTheme.HAS_BACKGROUND : CarouselTheme.DEFAULT"
    >
      <ul #tabsNavi class="unstyled flex flex--no-wrap" role="tablist">
        <ng-container [ngSwitch]="theme">
          <ng-template ngSwitchDefault>
            <li
              *ngFor="let tab of tabs; let i = index"
              class="tab tab--default nordic-blue-900-text"
              [ngClass]="{
                active: tab.active,
                'active-style': tab.active
              }"
            >
              <button
                class="tab-button font-body-1 ps-xsmall-y ps-medium-x"
                [disabled]="tab.disabled"
                (click)="selectTab(tab)"
                [attr.aria-selected]="tab.active"
                [attr.aria-controls]="tab.id"
                [ngClass]="{
                  'ps-medium-y ps-large-x': theme === TabTheme.IN_MODAL,
                  flex: tab.icon && tab.icon.position === TabIconPosition.LEFT,
                  'flex--middle': tab.icon && tab.icon.position === TabIconPosition.LEFT
                }"
                role="tab"
                [id]="tab.id + '-tab'"
              >
                <fcom-icon
                  *ngIf="tab.icon.name"
                  class="ir-xsmall"
                  [class.ms-xxsmall-r]="tab.icon && tab.icon.position === TabIconPosition.LEFT"
                  [name]="tab.icon.name"
                ></fcom-icon>
                <span class="tab-title flex medium-type">
                  {{ tab.title }}
                  <ng-container
                    *ngIf="tab.contentTooltip"
                    [ngTemplateOutlet]="tooltip"
                    [ngTemplateOutletContext]="{ contentTooltip: tab.contentTooltip }"
                  ></ng-container>
                </span>
                <span class="tab-subtitle block light-type" *ngIf="tab.subtitle">{{ tab.subtitle }}</span>
              </button>
            </li>
          </ng-template>
          <ng-template [ngSwitchCase]="TabTheme.CLASSIC">
            <li
              *ngFor="let tab of tabs; let i = index"
              class="tab--classic flex-1 flex--nogrow flex--basis0 border ms-xxsmall-t"
              [class.tab--classic--selected]="tab.active"
              [attr.aria-selected]="tab.active"
              [ngClass]="tab.active ? 'white-bg' : 'nordic-blue-50-bg'"
            >
              <button
                class="tab-button nordic-blue-900-text block fill no-bg border-none flex flex--middle flex--column flex--start ps-medium-t ps-xxsmall-x"
                [disabled]="tab.disabled"
                (click)="selectTab(tab)"
                [attr.aria-controls]="tab.id"
                role="tab"
                [id]="tab.id + '-tab'"
              >
                <span class="tab-title block font-body-1 bold-type" *ngIf="tab.title">
                  {{ tab.title }}
                  <ng-container
                    *ngIf="tab.contentTooltip"
                    [ngTemplateOutlet]="tooltip"
                    [ngTemplateOutletContext]="{ contentTooltip: tab.contentTooltip }"
                  ></ng-container>
                </span>
                <span class="tab-subtitle block font-body-1 ms-xsmall-b">
                  {{ tab.subtitle }}
                </span>
              </button>
            </li>
          </ng-template>
          <ng-template [ngSwitchCase]="TabTheme.STRETCH">
            <li
              *ngFor="let tab of tabs; let i = index"
              class="tab--stretch flex-1 flex--basis0 border ms-xxsmall-t"
              [attr.aria-selected]="tab.active"
              [ngClass]="tab.active ? 'tab--stretch--selected' : 'nordic-blue-50-bg'"
            >
              <button
                class="tab-button nordic-blue-900-text block fill no-bg border-none flex flex--center flex--column flex--start {{
                  tabStyleOverrideClasses || 'ps-medium-t ps-xxsmall-x'
                }}"
                [disabled]="tab.disabled"
                (click)="selectTab(tab)"
                [attr.aria-controls]="tab.id"
                role="tab"
                [id]="tab.id + '-tab'"
              >
                <span class="tab-title block font-body-1 bold-type" *ngIf="tab.title">
                  {{ tab.title }}
                  <ng-container
                    *ngIf="tab.contentTooltip"
                    [ngTemplateOutlet]="tooltip"
                    [ngTemplateOutletContext]="{ contentTooltip: tab.contentTooltip }"
                  ></ng-container>
                </span>
                <span class="tab-subtitle block font-body-1 {{ tabStyleOverrideClasses ? '' : 'ms-xsmall-b' }}">
                  {{ tab.subtitle }}
                </span>
              </button>
            </li>
          </ng-template>

          <ng-template #tooltip let-contentTooltip="contentTooltip">
            <button
              data-test-tooltip
              type="button"
              fcomTooltip
              [options]="{ closeOnScroll: true }"
              [content]="contentTooltip"
              [ariaCloseText]="'actions.close' | finLocalization"
              [attr.aria-label]="'actions.info' | finLocalization"
              class="icon nordic-blue-900-text ms-xxsmall-l"
            >
              <fcom-icon name="help-block" class="is-xsmall"></fcom-icon>
            </button>
          </ng-template>
        </ng-container>
      </ul>
    </fcom-carousel>
    <div class="flex--nogrow mobile-right">
      <ng-content select="tabSidebar"></ng-content>
    </div>
  </div>
</div>
<div
  class="tab-content"
  [class.tab-content--in-modal]="theme === TabTheme.IN_MODAL"
  [class.tab-content--stretch]="theme === TabTheme.STRETCH"
  [class.tab-content--default]="theme === TabTheme.DEFAULT"
  [class.tab-content--classic]="theme === TabTheme.CLASSIC"
  [class.tab-content--has-background]="theme === TabTheme.HAS_BACKGROUND"
>
  <ng-content></ng-content>
</div>
